import React from 'react';

const SkeletonLoader = ({ type = 'card', count = 1 }) => {
    const renderSkeleton = () => {
        switch (type) {
            case 'card':
                return (
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden animate-pulse">
                        <div className="h-72 bg-gray-200"></div>
                        <div className="p-5 space-y-3">
                            <div className="grid grid-cols-2 gap-3">
                                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                                <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                            </div>
                            <div className="pt-4 flex gap-3">
                                <div className="h-10 bg-gray-200 rounded-xl flex-1"></div>
                                <div className="h-10 bg-gray-200 rounded-xl flex-1"></div>
                            </div>
                        </div>
                    </div>
                );
            case 'list':
                return (
                    <div className="flex items-center space-x-4 p-4 bg-white rounded-xl shadow-sm border border-gray-100 animate-pulse">
                        <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
                        <div className="flex-1 space-y-2">
                            <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                            <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                        </div>
                    </div>
                );
            case 'profile':
                return (
                    <div className="max-w-5xl mx-auto animate-pulse">
                        <div className="h-48 bg-gray-200 rounded-3xl mb-8"></div>
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                            <div className="lg:col-span-2 space-y-8">
                                <div className="h-40 bg-gray-200 rounded-3xl"></div>
                                <div className="h-64 bg-gray-200 rounded-3xl"></div>
                            </div>
                            <div className="space-y-6">
                                <div className="h-40 bg-gray-200 rounded-3xl"></div>
                                <div className="h-64 bg-gray-200 rounded-3xl"></div>
                            </div>
                        </div>
                    </div>
                );
            default:
                return <div className="h-20 bg-gray-200 rounded-xl animate-pulse"></div>;
        }
    };

    return (
        <>
            {Array(count).fill(0).map((_, index) => (
                <div key={index} className="w-full">
                    {renderSkeleton()}
                </div>
            ))}
        </>
    );
};

export default SkeletonLoader;
